module.exports = __webpack_public_path__ + "img/Elefant_1.5eef7681.jpeg";